/** Zod validation schemas for Static Site Hosting endpoints */

import { z } from 'zod'

export const listSitesQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(100).default(20).optional(),
  offset: z.coerce.number().int().min(0).default(0).optional(),
  search: z.string().max(100).optional(),
})

export const updateSiteSchema = z.object({
  title: z.string().min(1).max(200).optional(),
  description: z.string().max(1000).optional(),
  isPublic: z.boolean().optional(),
})
